/* ECLO — A3 mobile progressive enhancement.
   Three new pages only, never A2/live. Actual V11 study nodes are moved
   into native details/summary, not cloned; desktop restores exact articles.
   No cart or selling-plan writes. */
(function(){
 'use strict';
 if(window.ECLOSupplementA3Mobile){window.ECLOSupplementA3Mobile.refresh();return;}
 var mq=window.matchMedia('(max-width:749px)');
 function node(tag,cls,str){
   var el=document.createElement(tag);
   if(cls)el.className=cls;
   if(str!==undefined)el.textContent=str;
   return el;
 }
 function allRoots(){return Array.prototype.slice.call(document.querySelectorAll('[data-eclo-a3-mobile]'));}
 function getParts(root){
   var section=document.querySelector('.ev11-science[id^="R5Science--"]')||document.querySelector('.ev11-science');
   return {root:root,section:section,review:root.querySelector('.eclo-v9-reviewline'),
     price:root.querySelector('.ev11-ab-top-price'),titleRow:root.querySelector('.ev11-ab-title-row')};
 }
 function studyInfo(article){
   var h=article.querySelector('header');
   var active=h&&h.querySelector('.ev11-study__active')?.textContent.trim()||'';
   var badge=h&&h.querySelector('.ev11-study__badge')?.textContent.trim()||'';
   var title=h&&h.querySelector('h3')?.textContent.trim()||'';
   var protocol=article.querySelector('.ev11-study__protocol');
   var dd=protocol?Array.from(protocol.querySelectorAll('dd')):[];
   return {active:active,badge:badge,title:title,participants:dd[0]?.textContent.trim()||'',
     dose:dd[1]?.textContent.trim()||'',duration:dd[2]?.textContent.trim()||''};
 }
 function wrap(section){
   if(!section||section.classList.contains('eclo-a3-accordion-ready'))return;
   var parent=section.querySelector('.ev11-studies');
   if(!parent)return;
   var articles=Array.from(parent.children).filter(function(el){return el.matches('article.ev11-study');});
   if(!articles.length)return; 
   articles.forEach(function(article,i){
     var details=node('details','eclo-a3-study');
     details.open=i===0;
     var summary=node('summary','');
     var content=node('span','eclo-a3-summary-content');
     var info=studyInfo(article);
     var label=[info.active,info.duration].filter(Boolean).join(' · ');
     content.appendChild(node('span','eclo-a3-summary-kicker',label));
     content.appendChild(node('strong','eclo-a3-summary-title',info.title));
     var meta=[info.participants,info.dose,info.badge].filter(Boolean).join(' · ');
     if(meta)content.appendChild(node('span','eclo-a3-summary-meta',meta));
     summary.appendChild(content);
     var plus=node('span','eclo-a3-summary-more','+');
     plus.setAttribute('aria-hidden','true');
     summary.appendChild(plus);
     details.appendChild(summary);
     parent.insertBefore(details,article);
     details.appendChild(article);
   });
   section.classList.add('eclo-a3-accordion-ready');
   section.dataset.ecloA3StudyCount=String(articles.length);
 }
 function unwrap(section){
   if(!section||!section.classList.contains('eclo-a3-accordion-ready'))return;
   section.querySelectorAll('.ev11-studies > details.eclo-a3-study').forEach(function(details){
     var article=details.querySelector(':scope > article.ev11-study');
     if(article)details.parentNode.insertBefore(article,details);
     details.remove();
   });
   section.classList.remove('eclo-a3-accordion-ready');
 }
 function refresh(){
   allRoots().forEach(function(root){
     var a=getParts(root);
     if(!a.section)return;
     if(mq.matches){
       if(a.price&&a.review&&a.price.parentElement!==a.review)a.review.appendChild(a.price);
       wrap(a.section);
       root.dataset.ecloA3MobileActive='true';
     }else{
       if(a.price&&a.titleRow&&a.price.parentElement!==a.titleRow)a.titleRow.appendChild(a.price);
       unwrap(a.section);
       root.dataset.ecloA3MobileActive='false';
     }
     root.ecloA3Inspect=function(){
       var h1=root.querySelector('h1');
       var range=document.createRange();
       if(h1)range.selectNodeContents(h1);
       var titleRects=h1?Array.from(range.getClientRects()):[];
       var st=a.section;
       return {mobile:mq.matches,width:window.innerWidth,documentWidth:document.documentElement.scrollWidth,
         hasHorizontalOverflow:document.documentElement.scrollWidth>window.innerWidth,
         title:h1?.textContent.trim()||'',titleFont:h1?getComputedStyle(h1).fontSize:'',
         titleLineRects:titleRects.length,
         headlinePrice:a.price?.textContent.trim()||'',priceParent:a.price?.parentElement?.className||'',
         studyRecords:st.querySelectorAll('article.ev11-study').length,
         mobileAccordions:st.querySelectorAll('details.eclo-a3-study').length,
         firstAccordionOpen:!!st.querySelector('details.eclo-a3-study')?.open,
         nativeOfferReady:root.dataset.abReady,
         product:root.getAttribute('data-eclo-a3-mobile')};
     };
   });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh,{once:true});else refresh();
 if(mq.addEventListener)mq.addEventListener('change',refresh);
 else if(mq.addListener)mq.addListener(refresh);
 document.addEventListener('shopify:section:load',refresh);
 window.ECLOSupplementA3Mobile={refresh:refresh};
})();
